import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    anchor: {
        alignSelf: "flex-start",
        position: "relative"
    },
    stretchedAnchor: {
        alignSelf: "stretch"
    }
});
export default stylesheet;
